module.exports = __webpack_public_path__ + "img/yangyu.84a7579d.jpg";